import { useEffect, useState } from "react";
import { LoadPanel, Popup } from "devextreme-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Toster } from "../../components/Toster/Toster";
import { DynamicTabb } from "../../components/DynamicTab/DynamicTab";
import { Table2 } from "../../components/Table2/Table2";
import AdminCrumbs from "./components/AdminCrumbs";
import AddEditOffense from "./AddEditOffense";
import { handleGetLocal } from "../../services/auth-service";

const Offenses = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMode, setPopupMode] = useState("ADD");
  const [selectedRow, setSelectedRow] = useState(null);
  const pathname = handleGetLocal("pathURL");

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });

  const Tablecoloum = [
    { title: "", moreoption: true, customwidth: "50px" },
    { title: "Offense Name", customwidth: "300px" },
    { title: "Offense Type", customwidth: "200px" },
    { title: "Conviction Type", customwidth: "200px" },
  ];

  const setTableData = (apiData) => {
    const arr = apiData.map((val) => ({
      ID: val.gOffenseId,
      "Offense Name": val.sName,
      "Offense Type": val.sOffenseType,
      "Conviction Type": val.sConvictionType,
      obj: val,
    }));
    setData(arr);
  };

  const getOffenses = () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/get-offenses`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((res) => {
        setTableData(res?.data?.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setToastConfig({
          isVisible: true,
          type: "error",
          message: "Failed to load Offenses",
        });
      });
  };

  useEffect(() => {
    getOffenses();
  }, []);

  return (
    <>
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />

      <Popup visible={popupOpen} showTitle={false} width={600} height="auto" onHiding={() => setPopupOpen(false)}>
        <AddEditOffense
          mode={popupMode}
          rowData={selectedRow}
          setPopupOpen={setPopupOpen}
          refresh={getOffenses}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
        />
      </Popup>

      <AdminCrumbs title="Offenses" user="Data" />

      <div className="fee-schedule-container">
        <DynamicTabb />
        <div className="fee-schedule-content">
          <p className="page-info-number">DK.18</p>

          <div className="fee-schedule-buttons">
            <div className="buttons">
              <button
                className="btn"
                onClick={() => {
                  setPopupMode("ADD");
                  setSelectedRow(null);
                  setPopupOpen(true);
                }}
              >
                Add
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_6247_15083)">
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6247_15083">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              {/* 
              <button className="btn" onClick={getOffenses}>
                Refresh
              </button> */}
            </div>
          </div>
        </div>

        <Table2
          Tablecoloum={Tablecoloum}
          tableRow={data}
          editTable={false}
          load={loading}
          coloumWidthText={"Offenses"}
          height={"auto"}
          showTotalBlock={false}
          exportwidth={16.3}
          OffensesMenu={true}
          setOffensePopupOpen={setPopupOpen}
          setOffenseRowData={setSelectedRow}
          setEditOffenseMode={setPopupMode}
        />
      </div>
    </>
  );
};

export default Offenses;
